import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {
	VisibleElementsSnappingControlsElementsConfiguration
} from "./visible-elements-snapping-controls-elements-configuration";

@JsonObject()
export class EditorVisibleElementsConfiguration  {
    /**
     * _Since 4.28_.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Editor.html#VisibleElements)
     */
    @JsonProperty()
    declare createFeaturesSection?: boolean;
    /**
     * _Since 4.28_.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Editor.html#VisibleElements)
     */
    @JsonProperty()
    declare editFeaturesSection?: boolean;
    /**
     * _Since 4.29_.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Editor.html#VisibleElements)
     */
    @JsonProperty()
    declare labelsToggle?: boolean;
    /**
     * _Since 4.29_.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Editor.html#VisibleElements)
     */
    @JsonProperty()
    declare tooltipsToggle?: boolean;
    /**
     * Indicates whether to display the `SnappingControls` widget.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Editor.html#VisibleElements)
     */
    @JsonProperty()
    declare snappingControls?: boolean;
    /**
     * The available [SnappingControls](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-support-SnappingControls.html) elements within the widget.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Editor.html#VisibleElements)
     */
    @JsonProperty()
    declare snappingControlsElements?: VisibleElementsSnappingControlsElementsConfiguration;

    constructor() {}
}
